import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import Image from '../Image';
import css from './CarouselSlider.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CarouselSlider = function CarouselSlider(_ref) {
  var items = _ref.items,
      name = _ref.name;
  return /*#__PURE__*/_jsx("div", {
    className: css.root,
    children: /*#__PURE__*/_jsx("ul", {
      "aria-label": "Carousel ".concat(name),
      className: css.items,
      tabIndex: 0 // eslint-disable-line
      ,
      children: items.map(function (item) {
        var itemTitle = item.itemTitle,
            url = item.url,
            image = item.image;
        var key = "item-".concat(image.src);

        var inner = /*#__PURE__*/_jsxs(_Fragment, {
          children: [!!itemTitle && /*#__PURE__*/_jsx("div", {
            className: css.itemTitle,
            children: itemTitle
          }), !!image && /*#__PURE__*/_jsx("div", {
            className: css.item,
            children: /*#__PURE__*/_jsx(Image, _objectSpread({}, image))
          })]
        });

        var itemEl = url ? /*#__PURE__*/_jsx("a", {
          href: url,
          children: inner
        }) : inner;
        return /*#__PURE__*/_jsx("li", {
          "aria-label": "Carousel Item ".concat(name),
          className: css.itemWrap,
          tabIndex: -1,
          children: itemEl
        }, key);
      })
    })
  });
};

CarouselSlider.propTypes = {
  name: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    image: PropTypes.shape({
      alt: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired
    }),
    title: PropTypes.string,
    url: PropTypes.string
  })).isRequired
};
export default CarouselSlider;